// extracted by mini-css-extract-plugin
export default {"cookieSections":"Legal_cookieSections__Wu2dS","legalImage":"Legal_legalImage__wWUis"};